import React, { Fragment ,useState,useEffect} from "react";

import { Grid, Button, Dropdown, Form, Image } from "semantic-ui-react";
import { Helmet } from "react-helmet";
import BArrowImg from "../../../_assets/Arrow 1.png";
import "./VMCreate.css";
import WaitingLoder from "../Loader/waitingLoader";


const statusOptions = [
  { key: "yes", text: "Yes", value: 1 },
  { key: "no", text: "No", value: 0 },
];


const CreateVendingMachineForm = ({
  name,
  vmStreet,
  imageId,
  sharePercentage,
  remoteBluetoothId,
  remoteBoardId,
  remoteComId,
  remoteDeviceId,
  lat,
  lng,
  onChangeOfName,
  onChangeOfVMStreet,
  onChangeOfVMCity,
  onChangeOfVMState,
  onChangeOfVMCohort,
  onChangeOfPayments,
  onChangeOfLng,
  onChangeOfLat,
  onChange_Capacity,
  onChangeOfSharePercentage,
  onChangeOfRemoteBoardId,
  onChangeOfRemoteBluetoothId,
  onChangeOfRemoteComId,
  onChangeRemoteDeviceId,
  onChangeOfVMTypeId,
  onChangeOfHardWareTypeId,
  onChangeOfLocationTypeId,
  onChangeOfIsConsumerAppEnabled,
  handleCreateVM,
  handleBack,
  loading,
  vmTypeOptions,
  vmTypeLoading,
  stateLoading,
  stateList,
  cityList,
  cityLoading,
  vmSeedMachineData,
  cohorts,
  payments,
  hardware_types,
  location_types,
  warehouses,
  corporates,
  machine_types,
  cohortvalue,
  paymentsvalues,
  cart_Limt,
  onChangeCartLimit,
  
  onChangeOfSerialNo,
  onChangeOfName_mv,
  onChangeOfName_sv,
  onChangeOWarehouse,
  onChangeCorporates,
  onChangeOfIsHealthAppEnabled,
  UploadImgFun,
  UploadImgBtn,
  allPermission,
  loader

  

}) => {
  
  console.log("loctiontype",location_types)
  console.log("cohorts----create",cohorts)
  const [inputFields, setInputFields] = useState([
    {
      slot_id: null,
      mv_id: null,
      capacity: null
    } 
  ]);

 
  const [searchQuery, setsearchQuery] = useState([]);


 
  const [psearchQuery, setpsearchQuery] = useState([]);
 
  const resetForm = (e) => setInputFields([  {
    slot_id: null,
    mv_id: null,
    capacity: null
    }]);

 
  const handleSearchChange = (e, { searchQuery }) => {
    setsearchQuery(searchQuery);
    console.log("search", searchQuery);
  };
  

  const handleAddFields = () => {
    const values = [...inputFields];
    values.push( {
      slot_id: null,
      mv_id: null,
      capacity: null
      });
    setInputFields(values);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };


  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === "slot_id") {
      values[index].slot_id = event.target.value;
    } else if((event.target.name === "mv_id")){
      values[index].mv_id = event.target.value;
    }
    else if((event.target.name === "capacity")){
      values[index].capacity = event.target.value;
    }

    setInputFields(values);
    console.log("cohorts",cohorts)
  };

  const handleSubmit = (e,inputFields) => {
    
    e.preventDefault();
    console.log("_______________________________________-",inputFields)
    handleCreateVM(inputFields)
    // handle form submission here
   /*  alert(JSON.stringify(inputFields, null, 2)); */
  };



 
  const phandleSearchChange = (e, { psearchQuery }) => {
    setpsearchQuery(psearchQuery);
    console.log("search", psearchQuery);
  };

  
  
  return(
  
 <Fragment>
  {loader&&<WaitingLoder/>}
  {allPermission && allPermission.role_id == 1 ? <Grid centered style={{ marginTop: "0px", padding: "10vh" }}>
    {console.log("cohorts",cohorts)}
       <Helmet>
      <title>Create New Vending Machine </title>
    </Helmet>
    <Grid.Row Column={3} style={{ display: "flex", "justify-content": "just" }}>
      <Grid.Column width={1}>
        <span style={{ "margin-top": "1.5rem" }}>
          <Image  onClick={handleBack} className={"backarrow"} src={BArrowImg} />
        </span>
      </Grid.Column>
      <Grid.Column width={9}>
        <h2>Create New Vending Machine</h2>
      </Grid.Column>
    </Grid.Row>
    
    
    <Grid.Row loading={loading} style={{ marginBottom: "8em" }}>
      <Grid.Column width={8}>


  {      <Form>
          <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>VM NAME</label>
            <input
              placeholder="Enter Machine Name"
              value={name}
              onChange={onChangeOfName}
              
              style={{
                        
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
            />
          </Form.Field>

        
          <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>VM TYPE</label>
            <Dropdown
              placeholder="Select Machine Type"
              //loading={loading}
              selection
              search
              options={machine_types}
              onChange={onChangeOfVMTypeId}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

          <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>HARDWARE TYPE</label>
            <Dropdown
              placeholder="Select Hardware Type"
             // loading={loading}
              selection
              search
              options={hardware_types}
              onChange={onChangeOfHardWareTypeId}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

          <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>WAREHOUSE </label>
            <Dropdown
              placeholder="Select Warehouse Type"
              //loading={loading}
              selection
              search
              options={warehouses}
              onChange={onChangeOWarehouse}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

          <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>CORPORATE </label>
            <Dropdown
              placeholder="Select Corporate Type"
              //loading={loading}
              selection
              search
              options={corporates}
              onChange={onChangeCorporates}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

          <Form.Field  style={{"margin-bottom": "3rem"}}>
            <label>CONSUMER APP ENABLED</label>
            <Dropdown
              placeholder="Select Status"
              selection
              disabled={loading || vmTypeLoading}
              options={statusOptions}
              onChange={onChangeOfIsConsumerAppEnabled}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

          <Form.Field  style={{"margin-bottom": "3rem"}}>
            <label>HEALTH APP ENABLED</label>
            <Dropdown
              placeholder="Select Status"
              selection
              disabled={loading || vmTypeLoading}
              options={statusOptions}
              onChange={onChangeOfIsHealthAppEnabled}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>
          <Form.Field required  style={{"margin-bottom": "3rem"}}>
            <label>SHARE PERCENTAGE</label>
            <input
             type="number"
              placeholder="Example: 0.5 or 1.2"
              value={sharePercentage}
              onChange={onChangeOfSharePercentage}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>
         

          <Form.Dropdown 
            label="COHORTS"
            fluid
            /* required */
            multiple
            onChange={onChangeOfVMCohort}
           options={cohorts} 
            placeholder="Add Cohort"
            search
         
            selection
          
            style={{
                        
              "border-color": "white",
              "font-size": "20px",
              "background-color": "#f7f7f7",
            }}
            
            />
            
            <Form.Dropdown 
            label="PAYMENTS"
            placeholder="Add Payment"
            fluid
            multiple
            /* required */
            onChange={onChangeOfPayments}
            onSearchChange={phandleSearchChange}
            options={payments}
            key={payments.id}
            
            search
            searchQuery={psearchQuery}
            selection
            value={paymentsvalues}
            style={{
                        
              "border-color": "white",
              "font-size": "20px",
              "background-color": "#f7f7f7",
            }}
            
            />

           
          <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>SERIAL NUMBER</label>
            <input
              placeholder="Enter Your Serial Number"
              onChange={onChangeOfSerialNo}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

    <form onSubmit={(e)=>{handleSubmit(e,inputFields)}}>
        <div className="form-row">
          {inputFields.map((inputField, index) => (
            <Fragment key={`${inputField}~${index}`}>
              <div className="form-group col-sm-6">
                <label style={{"font-size": "18px","font-weight": "700",color:"rgb(96 96 96 / 87%)"}}>SLOT ID</label>
                <input
                  type="number"
                  className=""
                  id="slot_id"
                  name="slot_id"
                
                  value={inputField.slot_id}
                  onChange={(event) => handleInputChange(index, event)}
                  style={{
                        
                    "border-color": "white",
                    "font-size": "20px",
                    "background-color": "#f7f7f7",
                    "margin-bottom": "3rem",
                    "margin-top": "1rem"
                  }}
                
                />
              </div>
              <div className="form-group col-sm-4">
              <label style={{"font-size": "18px","font-weight": "700",color:"rgb(96 96 96 / 87%)"}}>MV ID</label>
                <input
                  type="text" 
                  className="form-control" 
                  id="mv_id"
                  name="mv_id"
                  value={inputField.mv_id}
                  onChange={event => handleInputChange(index, event)}
                  style={{
                        
                    "border-color": "white",
                    "font-size": "20px",
                    "background-color": "#f7f7f7",
                    "margin-bottom": "3rem",
                    "margin-top": "1rem"
                  }}
                />
              </div>
              <div>

              <div className="form-group col-sm-4">
                <label style={{"font-size": "18px","font-weight": "700",color:"rgb(96 96 96 / 87%)"}}>CAPACITY</label>
                <input
                  type="text" 
                  className="form-control" 
                  id="capacity"
                  name="capacity"
                  value={inputField.capacity}
                  onChange={event => handleInputChange(index, event)}
                  style={{
                        
                    "border-color": "white",
                    "font-size": "20px",
                    "background-color": "#f7f7f7",
                    "margin-bottom": "1rem",
                    "margin-top": "1rem"
                  }}
                />
              </div>

        {/*       <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>CART LIMIT</label>
            <Dropdown
              placeholder="Select Cart Limit "
             // loading={loading}
              selection
              search
             options={cart_Limt}
            onChange={onChangeCartLimit} 
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field> */}
              <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>LOCATION TYPE</label>
            <Dropdown
              placeholder="Select Location Type"
             // loading={loading}
              selection
              search
              options={location_types}
              onChange={onChangeOfLocationTypeId}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>

              <div>
                <button
                  className=""
                  type="button"
                  disabled={index === 0}
                  onClick={() => handleRemoveFields(index)}
                >
                  -
                </button>
                <button
                  className=""
                  type="button"
                  onClick={() => handleAddFields()}
                >
                  +
                </button>
                </div>
              </div>
            </Fragment>
          ))}
        </div>

      </form>
    

       

     

          <Form.Field required>
            <label>UPLOAD IMAGE </label>
           
            <input
              type="file"
            /*   enctype="multipart/form-data" */
              placeholder="Example: VMLogo/Paytm_logo.png"
            
              onChange={UploadImgFun}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
            <button onClick={UploadImgBtn}>UPLOAD</button>
          
          </Form.Field>
         

          <Form.Field required style={{"margin-bottom": "3rem"}}>
            <label>LOCATION</label>
            <input
              placeholder="Example: Paytm B121 Sector 5 (Max 50 character)"
              value={vmStreet}
              onChange={onChangeOfVMStreet}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              }}
            />
          </Form.Field>
          <div style={{display:"flex",marginBottom:"3rem"}}>
          
          <Form.Field  style={{"width":"50%"}} >
          <Form.Dropdown
            required
            
            placeholder='State' 
            search 
            selection 
            //disabled={loading || stateLoading}
            options={stateList}
            onChange={onChangeOfVMState}
            
            style={{
                        
              "border-color": "white",
              "font-size": "20px",
              "background-color": "#f7f7f7",
            
              
            }}
          
          
          />

            </Form.Field>
          
       
        <Form.Field required style={{ "width":"52%","margin-left": "2px"}}>
       
           
            <Dropdown
              placeholder="Select City"
              selection
              search
             disabled={loading || cityLoading} 
              options={cityList}
              onChange={onChangeOfVMCity}
              style={{
                        
                "border-color": "white",
                "font-size": "20px",
                "background-color": "#f7f7f7",
              
                
              }}
            />
         
          </Form.Field>

     
          </div >


          <div  style={{"display": "flex",marginBottom:"3rem"}}>
           
           <Form.Field required style={{width:"52%"}}>
            <input
              placeholder="Latitude"
              value={lat}
              type="number"
              onChange={onChangeOfLat}
              style={{
                        
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
            />
          </Form.Field>
       
          
      
        <Form.Field required style={{width:"54%","margin-left": "2px"}}>
            <input
              placeholder="Longitude"
              value={lng}
              type="number"
              onChange={onChangeOfLng}
              style={{
                        
                        "border-color": "white",
                        "font-size": "20px",
                        "background-color": "#f7f7f7",
                      }}
            />
          </Form.Field>

      
          </div >

          <Button color='blue' onClick={e=>{handleSubmit(e,inputFields)}} style={{ width: "100%","padding": "20px","font-size": "20px"}}>CREATE</Button>

    
     
        </Form> }
      </Grid.Column>
    </Grid.Row>
  </Grid>:<h1>NO PERMISSION</h1>
  }

  </Fragment>

);
                    }

export default CreateVendingMachineForm;



// WEBPACK FOOTER //
// ./src/Modules/VMCreate/component.jsx